import React, { useState, useEffect } from "react";
import EventCardTV from "../components/events/event-card-tv";
import { getEventById } from "../services/event-service";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import ExceptionMessage from "../components/shared/exception-message";
import "../styles/components/events-tv.css";

export const EventTvPage = () => {
  let { id } = useParams();
  const [event, setEvent] = useState(null);
  const { getAccessTokenSilently } = useAuth0();
  const [eventLoadingError, setEventLoadingError] = useState(null);

  useEffect(() => {
    if (!id) return;
    const retrieveEvent = async () => {
      try {
        const token = await getAccessTokenSilently();
        const result = await getEventById(token, id);
        setEvent(result.data);
        if (result.error) {
          console.error("Error retrieving event:", result.error);
          setEventLoadingError(result.error);
        }
      } catch (err) {
        console.error("Error:", err);
        setEventLoadingError(err.message);
      }
    };
    retrieveEvent();
  }, [id, getAccessTokenSilently]);

  return (
    <div className="event-tv-page-wrapper">
      {eventLoadingError && (
        <div style={{ padding: "12px" }}>
          <ExceptionMessage message={"Oh no! There was an issue loading this event."} />
        </div>
      )}
      {event && !eventLoadingError && <EventCardTV event={event} eventId={id} />}
    </div>
  );
};
